import React, { useState } from "react";
import { TextField, Paper, Typography, Box, Button, Container, Alert, Stack } from "@mui/material";
import axios from "axios";
import DashboardLayout from '../Layout/DashboardLayout';
import { getCurrentUser, register } from '../../models/Account';
import { useEffect } from "react";

export default function AddAdmin() {
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [userRole, setUserRole] = useState("");

    useEffect(() => {
        getCurrentUser().then((user) => {
            if (user?.id) {
                setUserRole(user.role);
            } else {
                setError("Không lấy được thông tin người dùng");
            }
        });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = {
            username,
            email,
            password,
            role: "admin"
        }
        try {
            const res = await register(formData);
            setMessage(res[0].message);
            setError("");
            setUsername("");
            setEmail("");
            setPassword("");
        } catch (err) {
            setError(err.response?.data?.error || "Có lỗi xảy ra");
        }
    };

    return (
        <DashboardLayout>
            <Container maxWidth="sm" sx={{ mt: 4 }}>
                <Paper sx={{ p: 4 }}>
                    <Typography variant="h5" gutterBottom>🛠️ Tạo tài khoản Admin</Typography>

                    <Stack spacing={2} sx={{ mb: 2 }}>
                        {message && <Alert severity="success">{message}</Alert>}
                        {error && <Alert severity="error">{error}</Alert>}
                    </Stack>

                    <form onSubmit={handleSubmit}>
                        <Box mb={2}>
                            <TextField
                                label="Tên người dùng"
                                fullWidth
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </Box>
                        <Box mb={2}>
                            <TextField
                                label="Email"
                                type="email"
                                fullWidth
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Box>
                        <Box mb={3}>
                            <TextField
                                label="Mật khẩu"
                                type="password"
                                fullWidth
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Box>
                        <Button variant="contained" color="success" type="submit" fullWidth>
                            Tạo Admin
                        </Button>
                    </form>
                </Paper>
            </Container>
        </DashboardLayout>
    );
}
